import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const PaymentMessage = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const payments = booking.payment;
  const { t } = useTranslation();

  return (
    <div className="col-12">
      {!isAgency ? (
        <p style={{ color: "darkorange" }}> {payments.paymentTxt}</p>
      ) : (
        <p style={{ color: "darkorange" }}>
          {t("bookingDetails.payments.message")}
        </p>
      )}
    </div>
  );
};

export default PaymentMessage;
